import editImage from "../../../common/images/edit.svg";
import {
    setIsEditCertificateModalOpen,
    setSelectedCertificateId,
} from "../../../modals/EditCertificateModal/EditCertificateModalSlice";
import { Dispatch } from "redux";
import { CertificateInterface } from "../../../common/interfaces/CertificateInterface";
import { ModalButtonActionData } from "@hatch-digital-nl/abs-storybook/legacy";

interface Props {
    dispatch: Dispatch;
    item: CertificateInterface;
    isOpenFormLoading: boolean;
}

export const getActionData = (props: Props): ModalButtonActionData[] => {
    const { dispatch, item, isOpenFormLoading } = props;

    return [
        ...(!item.approved &&
        (item.expires_at === null || new Date(item.expires_at) >= new Date())
            ? [
                  {
                      iconUrl: editImage,
                      onClick: () => {
                          dispatch(setSelectedCertificateId(item.id));
                          dispatch(setIsEditCertificateModalOpen(true));
                      },
                      title: "Bewerken",
                      isLoading: isOpenFormLoading,
                  },
              ]
            : []),
    ];
};
